import React from "react";
import { CrudPage } from "../components/CrudPage";
import { NewsForm } from "../components/forms/NewsForm";
import { news } from "../services/api";
import { NEWS_CATEGORIES } from "../data/news";
import { TableFilterDefinition } from "../types";

const formatDate = (value?: string) =>
  value ? new Date(value).toLocaleDateString("fa-IR") : "—";

const columns = [
  { header: "عنوان", accessor: "title", isSortable: true },
  { header: "دسته‌بندی", accessor: "category", isSortable: true },
  {
    header: "منتخب",
    accessor: "isFeatured",
    isSortable: true,
    render: (item: any) => (item.isFeatured ? "✓" : "—"),
  },
  {
    header: "فعال",
    accessor: "isActive",
    isSortable: true,
    render: (item: any) => (item.isActive ? "✓" : "—"),
  },
  {
    header: "تاریخ ایجاد",
    accessor: "createdAt",
    isSortable: true,
    render: (item: any) => formatDate(item.createdAt),
  },
];

const newsFilterDefinitions: TableFilterDefinition[] = [
  {
    key: "title",
    label: "عنوان",
    type: "text",
    placeholder: "جست‌وجوی عنوان",
  },
  {
    key: "category",
    label: "دسته‌بندی",
    type: "select",
    options: NEWS_CATEGORIES.map((category) => ({
      value: category.id,
      label: category.title,
    })),
  },
  {
    key: "isFeatured",
    label: "وضعیت منتخب",
    type: "select",
    options: [
      { value: "true", label: "منتخب" },
      { value: "false", label: "غیرمنتخب" },
    ],
  },
  {
    key: "isActive",
    label: "وضعیت انتشار",
    type: "select",
    options: [
      { value: "true", label: "فعال" },
      { value: "false", label: "غیرفعال" },
    ],
  },
  {
    key: "createdFrom",
    label: "تاریخ ایجاد از",
    type: "date",
    placeholder: "تاریخ شروع",
    usePersianDatePicker: true,
  },
  {
    key: "createdTo",
    label: "تاریخ ایجاد تا",
    type: "date",
    placeholder: "تاریخ پایان",
    usePersianDatePicker: true,
  },
];

export const NewsManagementPage: React.FC = () => {
  return (
    <CrudPage
      title="اخبار"
      columns={columns}
      queryKey="news"
      resourceName="news"
      api={news}
      FormComponent={NewsForm}
      filterDefinitions={newsFilterDefinitions}
      initialSort={{ field: "createdAt", direction: "desc" }}
    />
  );
};
